import { render, staticRenderFns } from "./CatalogSelect.vue?vue&type=template&id=36bbf083&scoped=true"
import script from "./CatalogSelect.vue?vue&type=script&lang=js"
export * from "./CatalogSelect.vue?vue&type=script&lang=js"
import style0 from "./CatalogSelect.vue?vue&type=style&index=0&id=36bbf083&prod&scoped=true&lang=css"
import style1 from "@/assets/CatalogSelect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbf083",
  null
  
)

export default component.exports